module.exports = __webpack_public_path__ + "static/media/view1.798ec4e8.jpg";